<template>
    <v-sheet>
        <v-row :dense="true">
            <v-col>
                <v-sheet class="d-flex align-start flex-column">
                    <v-btn-toggle :divided="true" variant="outlined">
                        <v-btn
                            density="compact"
                            :disabled="job?.JobNum ? false : true"
                            @click="firstPart"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'backward-step']"
                                class="text-primary"
                            />
                        </v-btn>

                        <v-btn
                            density="compact"
                            :disabled="job?.JobNum ? false : true"
                            @click="previousPart"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'play']"
                                class="text-primary fa-rotate-180"
                            />
                        </v-btn>

                        <v-select
                            v-model="selectedMaterial"
                            :items="materialSelection"
                            variant="outlined"
                            density="compact"
                            :disabled="job?.JobNum ? false : true"
                            color="primary"
                            rounded="0"
                            hide-details
                            style="min-width: 10rem"
                        ></v-select>

                        <v-btn
                            density="compact"
                            :disabled="job?.JobNum ? false : true"
                            @click="nextPart"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'play']"
                                class="text-primary"
                            />
                        </v-btn>

                        <v-btn
                            density="compact"
                            :disabled="job?.JobNum ? false : true"
                            @click="lastPart"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'forward-step']"
                                class="text-primary"
                            />
                        </v-btn>
                    </v-btn-toggle>
                </v-sheet>
            </v-col>
        </v-row>

        <v-row class="pa-1" :dense="true">
            <v-col cols="2" class="d-flex align-center justify-end">
                <v-sheet>Mtl Seq:</v-sheet>
            </v-col>

            <v-col cols="2">
                <v-text-field
                    v-model="form.MtlSeq"
                    label="Mtl Seq"
                    variant="outlined"
                    density="compact"
                    color="primary"
                    hide-details
                    :readonly="parseInt(job?.JobClosed) !== 0"
                    @focusout="JobMtlSeqChange"
                    @keydown.enter="JobMtlSeqChange"
                    @keydown.tab="JobMtlSeqChange"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="pa-1" :dense="true">
            <v-col cols="2" class="d-flex align-center justify-end">
                <v-btn class="w-100" color="close" :disabled="parseInt(job?.JobClosed) !== 0" @click="openPartSearchDialog"
                    >Part/Rev
                </v-btn>
            </v-col>

            <v-col cols="3">
                <v-text-field
                    v-model="form.PartNum"
                    variant="outlined"
                    density="compact"
                    color="primary"
                    hide-details
                    :readonly="parseInt(job?.JobClosed) !== 0"
                    @focusout="JobMtlPartNumChange"
                    @keydown.enter="JobMtlPartNumChange"
                    @keydown.tab="JobMtlPartNumChange"
                ></v-text-field>
            </v-col>

            <v-col cols="2" class="d-flex align-center justify-end">
                <v-btn class="w-100" color="close" @click="openDescriptionDialog"
                    >Desc...</v-btn
                >
            </v-col>

            <v-col cols="5">
                <v-text-field
                    v-model="form.Description"
                    variant="outlined"
                    density="compact"
                    color="primary"
                    hide-details
                ></v-text-field>
            </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>

        <v-row class="pa-1" :dense="true">
            <v-col>
                <div class="section-heading font-weight-bold">
                    Related Operation
                </div>

                <v-row :dense="true">
                    <v-col cols="2" class="d-flex align-center justify-end">
                        <v-btn class="w-100" color="close" :disabled="parseInt(job?.JobClosed) !== 0" @click="openOperationSearchDialog"
                            >Operation</v-btn
                        >
                    </v-col>

                    <v-col cols="2">
                        <v-text-field
                            v-model="form.OprSeq"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            type="number"
                            placeholder="0"
                            hide-details
                            :readonly="true"
                            @click="openOperationSearchDialog"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="2">
                        <v-text-field
                            v-model="form.OpCode"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            hide-details
                            :readonly="true"
                            @click="openOperationSearchDialog"
                        ></v-text-field>
                    </v-col>

                    <v-col class="d-flex justify-end align-center" cols="2">
                        Warehouse:
                    </v-col>

                    <v-col cols="4">
                        <v-select
                            :items="warehouseArray"
                            item-value="name"
                            item-title="description"
                            v-model="form.WarehouseCode"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            hide-details
                            :readonly="true"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>

        <v-row class="bg-red-lighten-3 pa-1" :dense="true">
            <v-col>
                <div class="section-heading font-weight-bold">Quantity</div>

                <v-row :dense="true">
                    <v-col class="d-flex justify-end align-center" cols="2">
                        {{ form.FixedQty === "1" ? 'Fixed Quantity:' : 'Qty/Parent:'}}
                    </v-col>

                    <v-col cols="3" style="display: flex; gap: 5px; align-items: center;">
                        <v-btn
                            :disabled="parseInt(job?.JobClosed) !== 0"
                            @click="openQtyPerCalculator"
                            v-if="parseInt(form.FixedQty) === 0"
                        >
                            <v-icon
                                icon="mdi:mdi-calculator"
                                size="x-large"
                                class="button"
                            ></v-icon>
                        </v-btn>

                        <v-text-field
                            v-model="form.QtyPer"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            type="number"
                            step="0.001"
                            placeholder="0.000"
                            hide-details
                            :readonly="parseInt(job?.JobClosed) !== 0"
                            @focusout="JobMtlQtyPerChange"
                            @keydown.enter="JobMtlQtyPerChange"
                            @keydown.tab="JobMtlQtyPerChange"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="3">
                        <v-select
                            v-model="form.IUM"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            hide-details
                            :readonly="true"
                        ></v-select>
                    </v-col>

                    <v-col cols="2" class="d-flex justify-end">
                        <v-checkbox
                            class="d-flex justify-end"
                            label="Fixed Qty"
                            color="primary"
                            density="compact"
                            hide-details
                            :readonly="parseInt(job?.JobClosed) !== 0"
                            v-model="form.FixedQty"
                            value="1"
                            @change="JobMtlFixedQtyChange"
                        ></v-checkbox>
                    </v-col>
                </v-row>

                <v-row :dense="true">
                    <v-col cols="2" class="d-flex justify-end align-center">
                        Scrap:
                    </v-col>

                    <v-col cols="3">
                        <v-text-field
                            v-model="form.EstScrap"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            type="number"
                            placeholder="0.00"
                            hide-details
                            :readonly="parseInt(job?.JobClosed) !== 0 || parseInt(this.form.FixedQty) !== 0"
                            @focusout="JobMtlScrapChange"
                            @keydown.enter="JobMtlScrapChange"
                            @keydown.tab="JobMtlScrapChange"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="3">
                        <v-select
                            v-model="form.EstScrapType"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            hide-details
                            :readonly="parseInt(job?.JobClosed) !== 0 || parseInt(this.form.FixedQty) !== 0"
                            :items="['Q', '%']"
                            @update:modelValue="JobMtlScrapTypeChange"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row :dense="true">
                    <v-col class="d-flex justify-end align-center" cols="2">
                        Required Qty:
                    </v-col>

                    <v-col cols="3">
                        <v-text-field
                            v-model="form.RequiredQty"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            type="number"
                            placeholder="0.00"
                            hide-details
                            :readonly="true"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="3">
                        <v-select
                            v-model="form.IUM"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            hide-details
                            :readonly="true"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>
    </v-sheet>

    <v-dialog v-model="dialogs.partDescriptionDialog">
        <v-card>
            <v-card-text class="p-3 overflow-y-auto">
                <v-textarea v-model="form.Description" :readonly="true" variant="outlined"></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogs.partDescriptionDialog = false"
                    >Cancel
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogs.operationSearchDialog">
        <OperationsSearch @operationReceived="operationReceived" />
    </v-dialog>

    <v-dialog v-model="dialogs.partSearchDialog">
        <PartSearch @partNumberReceived="partNumberReceived" />
    </v-dialog>

    <v-dialog v-model="dialogs.qtyPerCalculatorDialog">
        <QtyPerCalculator @closeQtyPerCalculator="closeQtyPerCalculator" @qtyPerCalculatorReceived="qtyPerCalculatorReceived" />
    </v-dialog>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useJobEntryStore } from "../../../../../../stores/ProjectManagement/JobEntry";
import { mapWritableState } from "pinia";
import axios from "axios";
import PartSearch from "../../../../Part/PartSearch.vue";
import OperationsSearch from "../../../Modals/OperationsSearch.vue";
import QtyPerCalculator from "../../../../EngineeringWorkBench/MethodOfManufacturing/QtyPerCalculator.vue";

export default {
    name: "DetailWindow",
    computed: {
        ...mapWritableState(useJobEntryStore, [
            "currentMaterial",
            "currentAssemblyMaterials",
            "currentAssembly",
            "setCurrentMaterial",
            "relatedOperationByOpr",
            "setErrorMessage",
            "setTemporaryMessage",
            "refreshAssemblies",
            "overlay"
        ])
    },
    components: {
        PartSearch,
        OperationsSearch,
        QtyPerCalculator
    },
    data() {
        return {
            runningProcesses: {
                updatingMtlSeq: false,
                updatingPartNum: false,
                updatingOperationCode: false,
                updatingQuantityPer: false,
                updatingFixedQuantity: false,
                updatingScrapType: false,
                updatingRequiredQty: false,
                updatingMtlSeq: false
            },
            dialogs: {
                partSearchDialog: false,
                operationSearchDialog: false,
                partDescriptionDialog: false,
                qtyPerCalculatorDialog: false
            },
            warehouseArray: []
        }
    },
    mounted() {
        this.fetchWarehouses();
    },
    watch: {},
    setup() {
        const jobEntryStore = useJobEntryStore();
        const job = computed(() => jobEntryStore.job);
        const selectedMaterial = computed({
            get: () => jobEntryStore.currentMaterial?.MtlSeq,
            set: (value) => {
                jobEntryStore.setCurrentMaterial(value)
                this.parseData(value)
            }
        });

        const form = ref({
            MtlSeq: null,
            PartNum: null,
            Description: null,
            OprSeq: null,
            OpCode: null,
            QtyPer: null,
            RequiredQty: null,
            EstScrapType: null,
            EstScrap: null,
            IUM: null,
            MaterialMtlCost: null,
            FixedQty: null,
            AssemblySeq: null
        });

        const materialSelection = computed(() => {
            return jobEntryStore.currentAssemblyMaterials.length
                ? jobEntryStore.currentAssemblyMaterials.map((material) => {
                      return {
                          title: material.MtlSeq,
                          value: material.MtlSeq,
                      };
                  })
                : [];
        });

        jobEntryStore.$subscribe((mutation, state) => {
            if(state.currentMaterial){
                parseData(state.currentMaterial)
            }
        })

        onMounted(() => {
            if(jobEntryStore.currentMaterial){
                parseData(jobEntryStore.currentMaterial)
            }
        })

        const parseData = (data) => {
            let OprCode;
            jobEntryStore.currentAssemblyOperations.forEach((opr) => {
                if (opr.OprSeq === data?.RelatedOperation) {
                    OprCode = opr.OpCode
                }
            });

            form.value = {
                MtlSeq: data?.MtlSeq,
                PartNum: data?.PartNum,
                Description: data?.Description,
                OprSeq: data?.RelatedOperation,
                OpCode: OprCode,
                QtyPer: parseFloat(data?.QtyPer).toFixed(2),
                RequiredQty: parseFloat(data?.RequiredQty).toFixed(),
                EstScrapType: data?.EstScrapType ?? '%',
                EstScrap: parseFloat(data?.EstScrap).toFixed(2),
                IUM: data?.IUM ?? 'PC',
                MaterialMtlCost: data?.MaterialMtlCost,
                FixedQty: parseFloat(data?.FixedQty).toFixed(),
                AssemblySeq: data?.AssemblySeq,
                WarehouseCode: data?.WarehouseCode
            };
        }

        return {
            job,
            materialSelection,
            selectedMaterial,
            form,
        };
    },
    methods: {
        openQtyPerCalculator() {
            this.dialogs.qtyPerCalculatorDialog = true;
        },
        closeQtyPerCalculator() {
            this.dialogs.qtyPerCalculatorDialog = false;
        },
        qtyPerCalculatorReceived(val) {
            this.form.QtyPer = val;
            this.dialogs.qtyPerCalculatorDialog = false;
            this.JobMtlQtyPerChange();
        },
        fetchWarehouses() {
            axios
                .get(
                    route("api.buildings.index", {
                        countryCodeFK: "US",
                        state: "NY",
                    })
                )
                .then((res) => {
                    this.warehouseArray = res.data;
                });
        },
        openPartSearchDialog() {
            // this.dialogs.partSearchDialog = true;
        },
        openDescriptionDialog() {
            this.dialogs.partDescriptionDialog = true;
        },
        openOperationSearchDialog() {
            this.dialogs.operationSearchDialog = true;
        },
        partNumberReceived(partNum) {
            this.form.PartNum = partNum;
            this.JobMtlPartNumChange();
            this.dialogs.partSearchDialog = false;
        },
        operationReceived(operation) {
            this.form.OpCode = operation.OpCode;
            this.form.OprSeq = operation.OprSeq;
            this.form.OpDesc = operation.OpDesc;
            this.dialogs.operationSearchDialog = false;
            this.JobOperationChange()
        },
        async JobMtlPartNumChange() {
            if (!this.runningProcesses.updatingPartNum && this.form.PartNum !== this.currentMaterial.PartNum) {
                this.runningProcesses.updatingPartNum = true;

                this.currentMaterial.PartNum = this.form.PartNum;
                let params = {
                    type: 'MtlPartNum'
                }

                await this.sendUpdateCall(params);

                this.runningProcesses.updatingPartNum = false;
            }
        },
        async JobMtlSeqChange() {
            if (!this.runningProcesses.updatingMtlSeq && this.currentMaterial.MtlSeq !== this.form.MtlSeq) {
                this.runningProcesses.updatingMtlSeq = true;

                this.currentMaterial.MtlSeq = this.form.MtlSeq;
                let params = {
                    type: 'MtlSeq'
                }

                await this.sendUpdateCall(params);

                this.runningProcesses.updatingMtlSeq = false;
            }
        },
        async JobMtlQtyPerChange() {
            if (!this.runningProcesses.updatingQuantityPer && this.form.QtyPer !== this.currentMaterial.QtyPer) {
                this.runningProcesses.updatingQuantityPer = true;

                this.currentMaterial.QtyPer = this.form.QtyPer;
                let params = {
                    QtyPer: this.form.QtyPer,
                    type: 'MtlQtyPer'
                }

                await this.sendUpdateCall(params);

                this.runningProcesses.updatingQuantityPer = false;
            }
        },
        async JobMtlFixedQtyChange() {
            if (!this.runningProcesses.updatingFixedQuantity) {
                this.runningProcesses.updatingFixedQuantity = true;

                this.currentMaterial.FixedQty = this.form.FixedQty;
                let params = {
                    FixedQty: this.form.FixedQty,
                    type: 'MtlFixedQty'
                }

                await this.sendUpdateCall(params);

                this.runningProcesses.updatingFixedQuantity = false;
            }
        },
        async JobMtlScrapTypeChange() {
            if (!this.runningProcesses.updatingScrapType && this.form.EstScrapType !== this.currentMaterial.EstScrapType) {
                this.runningProcesses.updatingScrapType = true;

                this.currentMaterial.EstScrapType = this.form.EstScrapType;
                let params = {
                    EstScrapType: this.form.EstScrapType,
                    type: 'MtlScrapType'
                }

                await this.sendUpdateCall(params);

                this.runningProcesses.updatingScrapType = false;
            }
        },
        async JobMtlScrapChange() {
            if (!this.runningProcesses.updatingScrap && this.form.EstScrap !== this.currentMaterial.EstScrap) {
                this.runningProcesses.updatingScrap = true;

                this.currentMaterial.EstScrap = this.form.EstScrap;
                let params = {
                    EstScrap: this.form.EstScrap,
                    type: 'MtlScrap'
                }

                await this.sendUpdateCall(params);

                this.runningProcesses.updatingScrap = false;
            }
        },
        async JobOperationChange() {
            if (!this.runningProcesses.updatingOperationCode) {
                this.runningProcesses.updatingOperationCode = true;

                this.currentMaterial.OprSeq = this.form.OprSeq;
                let params = {
                    OprSeq: this.form.OprSeq,
                    type: 'MtlOperationCode'
                }

                await this.sendUpdateCall(params);

                this.runningProcesses.updatingOperationCode = false;
            }
        },
        async sendUpdateCall(additionalParams) {
            if (this.job.PartNum && this.job.JobNum && parseInt(this.job.JobClosed) === 0) {
                this.overlay = true;
                let params = {
                    MaterialId: this.currentMaterial.id,
                    JobNum: this.job.JobNum,
                    JobPartNum: this.job.PartNum,
                    MtlPartNum: this.form.PartNum,
                    MtlSeq: this.form.MtlSeq,
                    AssemblySeq: this.form.AssemblySeq,
                    Description: this.form.Description,
                }
                params = {...params, ...additionalParams}

                await axios.post(route('api.epicor.jobs.mtl.update'), params)
                    .then((response) => {
                        if (response.data.Status === 0) {
                            this.setErrorMessage(response.data.Message)
                        } else if (response.data.Status === 1) {
                            this.form.Description = response.data.Description
                            this.refreshAssemblies('material');
                            this.setTemporaryMessage("Value has been updated and saved");
                        }
                    })
                    .catch((response) => {
                        console.log('Err: ' + response)
                    })
            }
        },
        nextPart() {
            if (this.currentAssemblyMaterials.length < 2) { return; }

            let key = this.findCurrentKey();
            key += 1;
            if (key > this.currentAssemblyMaterials.length - 1) {
                key = 0;
            }
            this.setCurrentMaterial(this.currentAssemblyMaterials[key].MtlSeq);
        },
        previousPart() {
            if (this.currentAssemblyMaterials.length < 2) { return; }

            let key = this.findCurrentKey();
            key -= 1;
            if (key < 0) {
                key = this.currentAssemblyMaterials.length - 1;
            }
            this.setCurrentMaterial(this.currentAssemblyMaterials[key].MtlSeq);
        },
        firstPart() {
            this.setCurrentMaterial(this.currentAssemblyMaterials[0].MtlSeq);
        },
        lastPart() {
            this.setCurrentMaterial(this.currentAssemblyMaterials[this.currentAssemblyMaterials.length - 1].MtlSeq);
        },
        findCurrentKey() {
            let i = 0;
            for (const mtl of this.currentAssemblyMaterials) {
                if (mtl.MtlSeq === this.currentMaterial.MtlSeq) {
                    return i;
                }
                i += 1;
            }
        }
    }
};
</script>

<style scoped></style>
